<template>
  <div class="layout-menubar">
    <div
      class="layout-menubar-activeModule"
    >
      {{ name }}
    </div>
    <div class="layout-menubar-menuList">
      <slot name="menu">
        <menu-list
          :menus="menus"
          :selected="selected"
          :on-click="onClick"
        >
        </menu-list>
      </slot>
    </div>
  </div>
</template>

<script>
import MenuList from '../components/sidebar/menu-list'

export default {
  components: {
    MenuList,
  },
  props: {
    name: {
      type: String,
    },
    selected: {
      type: Array,
      default() {
        return [];
      },
    },
    onClick: {
      type: Function,
      default() {},
    },
    menus: {
      require: true,
      type: Array,
    },
  }
}
</script>

<style lang="scss">
@import '../assets/styles/_variable';

.layout-menubar {
  position: fixed;
  left: $layoutSidebarWidth;
  z-index: 999;
  top: $layoutHeaderHeight;
  width: 200px;
  height: calc(100% - #{$layoutHeaderHeight});
  background: #fffefe;
  border-right: 1px solid $borderColor;
  box-shadow: 0 2px 4px 0 rgba(0, 5, 8, .07);
  &-activeModule {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: $layoutSiderbarMenuWidth;
    height: $layoutHeaderHeight;
    padding-left: 20px;
    color: $mainColor;
    font-size: 14px;
    transform: translateY(-100%);

    align-items: center;
  }

  &-menuList {
    overflow-y: auto;
    overflow-y: auto;
    height: 100%;
  }
}
</style>

